import { render, staticRenderFns } from "./newProject.vue?vue&type=template&id=ba5b1fce&scoped=true"
import script from "./newProject.vue?vue&type=script&lang=js"
export * from "./newProject.vue?vue&type=script&lang=js"
import style0 from "./newProject.vue?vue&type=style&index=0&id=ba5b1fce&prod&scoped=true&lang=css"
import style1 from "./newProject.vue?vue&type=style&index=1&id=ba5b1fce&prod&lang=css"
import style2 from "./newProject.vue?vue&type=style&index=2&id=ba5b1fce&prod&scoped=true&lang=scss"
import style3 from "./newProject.vue?vue&type=style&index=3&id=ba5b1fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5b1fce",
  null
  
)

export default component.exports